import type { ScheduleState } from '../types';

const selectAllUpcomingAppts = (state: ScheduleState) => state.schedule.appts.upcoming;

export { selectAllUpcomingAppts };
